const testPublisher = process.env.USE_TEST_ADS === "true";
const publisher =
  process.env.NEXT_PUBLIC_UI_THEME === "core" ? "omni" : "omniekonomi";

const getPublisher = (): string => {
  if (testPublisher) {
    return "se-sch-test_publisher";
  }

  if (!publisher) {
    console.error("publisher is not defined");
  }

  return publisher;
};

export { getPublisher };
